import React from 'react';
import './styles/header-global.scss';

class HeaderGlobal extends React.Component {
  render() {
    return (
      <div
        id="global-nav"
        className="bg-light w-100 flex-grow-1 py-lg-3 order-3 order-lg-1">
        <div className="container">
          <div className="col d-lg-flex justify-content-lg-between global-nav-wrp position-relative">
            <ul className="col-first pt-4 pt-lg-0 pb-3 pb-lg-0 mb-5 mb-lg-0">
              <li>
                <a
                  href="#main"
                  className="visually-hidden-focusable bg-white p-0 m-0 position-absolute">
                  Skip to main content
                </a>
              </li>
              <li className="d-none d-lg-inline pe-lg-6">
                <a href="/">Consumer</a>
              </li>
              <li className="pe-lg-6">
                <a href="/small-business/services.jsp">Small Business</a>
              </li>
              <li>
                <a href="/business-services/business-services.html">Business</a>
              </li>
            </ul>
            <ul>
              <li className="pe-lg-6">
                <a href="/corporate/about-experian.html">About Experian</a>
              </li>
              <li className="pe-lg-6">
                <a href="/help/">Consumer Support</a>
              </li>
              <li className="pe-lg-6">
                <a href="/blogs/ask-experian/">Credit Advice</a>
              </li>
              <li>
                <a
                  rel="noopener"
                  target="_blank"
                  href="https://www.experianplc.com/contact-us/region/"
                  className="m-last-foc m-last-foc-main">
                  Global Sites
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default HeaderGlobal;
